import { Box, TextField, Tooltip, IconButton } from '@mui/material';
import { useEffect, useState, useCallback } from 'react';
import CustomTable from '../../components/CustomTable';
import CreateBankAcc from '../../pages/BankAcc/CreateBankAcc';
import GeneralModal from '../../components/GeneralModal';
import { useDispatch } from 'react-redux';
import { addTab } from '../../tabs/tabsSlice';
import API from '../../services/api';
import MainText from '../../components/MainText';
import { AccountBalance, Addchart, Business, PersonAdd, Search, AddCircle } from '@mui/icons-material';
import CustomModal from '../../components/CustomModal';
import CreateEPayment from '../EarlyPayment/CreateEPayment';
import CreateExecutive from '../Executive/CreateExecutive';
import CustomSwitch from '../../components/CustomSwitch';
import { useNavigate } from 'react-router-dom';

export default function ListSuppliers() {
  const [open, setOpen] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [supplier_id, setSupplier_id] = useState(0);
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ search: '', active: true });
  const [debouncedSearch, setDebouncedSearch] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(addTab({ label: 'Listado de Proveedores', path: '/suppliers/all-suppliers' }));
  }, [dispatch]);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearch(filters.search), 500);
    return () => clearTimeout(handler);
  }, [filters.search]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        search: debouncedSearch || undefined,
        active: filters.active,
      };
      const response = await API.get('suppliers/', { params });
      setSuppliers(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [debouncedSearch, filters.active]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const handleOpen = () => setOpen(true);
  const handleOpen2 = () => setOpenModal2(true);
  const handleOpen3 = () => setOpenModal3(true);

  const handleClose = () => setOpen(false);
  const handleClose2 = () => setOpenModal2(false);
  const handleClose3 = () => setOpenModal3(false);
  return (
    <>
      <MainText
        title={'Listado de proveedores'}
        subtitle={'Proveedores'}
        icon={Business}
      />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, px: 2, mb: 2 }}>
        <TextField
          label="Buscar proveedor"
          variant="standard"
          value={filters.search}
          onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
          InputProps={{ startAdornment: <Search sx={{ mr: 1, color: 'gray' }} /> }}
          sx={{ flex: 1, minWidth: 200 }}
        />
        <CustomSwitch
          name='active'
          label='Activos'
          initialValue={filters.active}
          onChange={(name, value) => setFilters(prev => ({ ...prev, [name]: value }))}
        />
        <Tooltip title='Agregar nuevo' placement='top'>
          <IconButton color="primary" onClick={() => navigate('/suppliers/create-new')}>
            <AddCircle />
          </IconButton>
        </Tooltip>
      </Box>
      <CustomTable
        suppliers={suppliers}
        loading={loading}
        handleOpen={handleOpen}
        handleOpen2={handleOpen2}
        handleOpen3={handleOpen3}
        setSupplier_id={setSupplier_id}
        refresh={fetchData}
      />

      <CustomModal
        open={open}
        handleClose={handleClose}
        title="Ingreso de pronto pago"
        icon={Addchart}
        headerColor="primary.main"
        component={CreateEPayment}
        width='auto'
        componentProps={{ supplier: supplier_id, setOpen: setOpen, onClose: () => setOpen(false), data: fetchData }}
      />
      <CustomModal
        open={openModal2}
        handleClose={handleClose2}
        title="Ingreso de ejecutivo"
        icon={PersonAdd}
        width='30%'
        headerColor="primary.main"
        component={CreateExecutive}
        componentProps=
        {{
          supplier: supplier_id,
          setOpen: setOpenModal2,
          onClose: () => setOpenModal2(false),
          data: fetchData,
          isModal: true
        }}
      />
      <CustomModal
        open={openModal3}
        handleClose={handleClose3}
        title="Ingreso de cuenta bancaria"
        icon={AccountBalance}
        width='30%'
        headerColor="primary.main"
        component={CreateBankAcc}
        componentProps=
        {{
          supplier: supplier_id,
          onClose: () => setOpenModal3(false),
          data: fetchData,
          setOpen:setOpenModal3
        }}
      />
    </>
  );
}